import { TextField } from '@mui/material'
import React from 'react'

type ExtraNotesProps = {
	value: string
	label: string
	presentational?: boolean
	onChangeHandler?: (event: React.ChangeEvent<HTMLInputElement>) => void
}

function ExtraNotes({
	value,
	label,
	presentational = true,
	onChangeHandler,
}: Readonly<ExtraNotesProps>): React.JSX.Element {
	return React.useMemo(
		() => (
			<TextField
				disabled={presentational}
				fullWidth
				multiline
				label={label}
				size='medium'
				placeholder='Nada a apresentar'
				value={value}
				onChange={onChangeHandler}
				InputProps={{
					sx: {
						fontFamily: 'Poppins, sans-serif',
						fontSize: '0.8125rem',
						flex: '1 0 0',
						fontWeight: 500,
						lineHeight: 1.3,
						color: 'var(--primary-dark)',
						padding: '0.75rem 1rem',
						cursor: presentational ? 'default' : 'text',
						pointerEvents: presentational ? 'none' : 'auto',
						'& > *.Mui-disabled': {
							borderColor:
								presentational && value !== null && value.length > 0
									? 'var(--warning) !important'
									: 'rgba(134, 149, 175, 0.00) !important',
							WebkitTextFillColor: 'var(--primary-dark) !important',
						},
						'& .MuiOutlinedInput-notchedOutline': {
							borderColor:
								presentational && value !== null && value.length > 0 ? 'var(--warning) !important' : 'initial',
						},
						'& .MuiInputBase-input': {
							fontFamily: 'inherit',
							fontWeight: 400,
							fontSize: 'inherit',
							color: 'var(--primary-dark)',
						},
					},
				}}
				sx={{
					'& .MuiFormLabel-root': {
						color: 'var(--primary-light)',
						fontFamily: 'Poppins, sans-serif',
						fontWeight: '400',
						fontSize: '0.875rem',
						letterSpacing: '0.15px',
						lineHeight: '0.75',
					},
				}}
			/>
		),
		[value],
	)
}

export default ExtraNotes
